import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../misc/StoreField";
import {apiClient} from "../../connection/BlinkApiConnection";
import {loadVersionedObjectFromResponse} from "../misc/StoreUtils";


// TODO @branch @Darius these objects should better mirror what the backend models do, inheriting a base model
export class MerchantPanel extends StoreObject {
    @field("Merchant") merchant;

    @field("MerchantSDKSettings") settingsVersion;
    @field("MerchantPanel") versionParent;

    @field(String) name;
    @field(Object) options;
    @field(Object) dashboardOptions;

    toString() {
        return this.name;
    }

    // TODO: Maybe have panelType as a DB field?
    getPrimaryPanelType() {
        return this.panelType ?? Object.keys(this.options ?? {})[0] ?? null;
    }

    isMocked() {
        return this.getStore() == null;
    }
}

export async function apiCreateMerchantPanel(data) {
    const response = await apiClient.post("merchant/create_panel/", data);
    return loadVersionedObjectFromResponse(MerchantPanelStore, response, null);
}

export async function apiEditMerchantPanel(data) {
    const response = await apiClient.post("merchant/edit_panel/", data);
    return loadVersionedObjectFromResponse(MerchantPanelStore, response, data.panelId);
}

export async function apiDeleteMerchantPanel(data) {
    return apiClient.post("merchant/delete_panel/", data);
}

export const MerchantPanelStore = MakeStore("MerchantPanel", MerchantPanel, {
    dependencies: ["Merchant", "MerchantSDKSettings"],
});
